import { combineReducers } from 'redux';
import studentProfileReducer from './Reducers/studentProfileReducer';
import adminReducer from './Reducers/adminReducer';
import socketReducer from './Reducers/socketReducer';

export const rootReducer = combineReducers({
    studentProfileReducer,
    adminReducer,
    socketReducer
});